<div class="page-container">
  <!-- Header -->
  
  <!-- Content Grid -->
  <div class="content-grid">

    <!-- Left Card -->
    <div class="card">
      <div class="cdtitle">Dosing Details</div>
      <table class="data-table">
        <tr>
          <th>Dosing Goals</th>
          <th>gal/d</th>
          <th>TPD</th>
        </tr>
       <tr *ngFor="let boardItem of site">
              <td><div class="appLabelText">{{ boardItem.tankName }}</div></td>
              <td><div class="padding_1">{{ boardItem.dosing_goal_gpd }}</div></td>
              <td><div class="padding_1">{{ boardItem.dosing_goal_tpd }}</div></td>
        </tr>
         <tr *ngIf="site.length > 1">
              <td><div class="appLabelText">Total</div></td>
              <td><div class="appLabelText">{{ totalGpd }}</div></td>
              <td><div class="appLabelText">{{ totalTpd }}</div></td>
            </tr>
      </table>
    </div>

    <!-- Middle Card (Wider) -->
    <div class="card card-wide">
      <div class="cdtitle">Dosing so far</div>
      <div class="table-wrapper">
        <table class="data-table">
          <tr>
            <th>gal/d</th>
            <th>gal/d</th>
            <th>h</th>
            <th>gal/d</th>
            <th>h</th>
            <th>gal/d</th>
            <th>h</th>
          </tr>
          <tr *ngFor="let boardItem of site">
              <td>{{ boardItem.dosing_IP_gpd_AM }}</td>
              <td>{{ boardItem.dosing_IP_gpd_1 }}</td>
              <td>{{ boardItem.dosing_IP_hour_1 }}</td>
              <td>{{ boardItem.dosing_IP_gpd_2 }}</td>
              <td>{{ boardItem.dosing_IP_hour_2 }}</td>
              <td>{{ boardItem.dosing_IP_gpd_3 }}</td>
              <td>{{ boardItem.dosing_IP_hour_3 }}</td>
            </tr>
            <tr>
              <td>AM</td>
              <td colspan="2" style="text-align:center">1</td>
              <td colspan="2" style="text-align:center">2</td>
              <td colspan="2" style="text-align:center">3</td>
            </tr>
        </table>
      </div>
    </div>

    <!-- Right Card -->
    <div class="card">
      <div class="cdtitle">Shoot for</div>
      <table class="data-table">
        <tr>
          <th>gal/d</th>
          <th>h</th>
          <th>h</th>
          <th>Delta</th>
        </tr>
       <tr *ngFor="let boardItem of site">
              <td>{{ boardItem.dosing_ShootFor }}</td>
              <td>{{ boardItem.dosing_hour }}</td>
              <td>{{ boardItem.dayH }}</td>
              <td>
                <div [ngClass]="boardItem.dosingDelta < 0 ? 'deltaMinus' : 'deltaPlus'">
                  {{ boardItem.dosingDelta < 0 ? boardItem.dosingDelta : '+' + boardItem.dosingDelta }}
                </div>
              </td>
            </tr>
      </table>
    </div>

  </div>
</div>
